import React from "react";

interface JobClientProvidedLocationProps {
    locations?: any[];
}

export const JobClientProvidedLocation = (props: JobClientProvidedLocationProps) => {
    const { locations } = props;

    if (!locations) {
        return null;
    }

    const clientLocations = [...new Set(
        locations
            .map((x) => x.geocoded_locations)
            .flat()
            .map((x) => x ? x.formatted_address : null)
    )]
        .filter((location) => location)
        .join("; ");

    if (!clientLocations) {
        return null;
    }

    return (
        <div><b>Client-provided location(s):</b>{" "}{clientLocations}</div>
    );
};
